// order_SaBNnAsJyeYIHu
// rzp_test_MuW12ePvQ8Q5BH

import { useState } from "react";
import { Toast } from "../Utils/general-function";
import { RazorpayScriptLoad } from "./RazorpayScriptLoad";

const useRazorpayPayment = () => {
  const [status, setStatus] = useState("idle");

  const handlePayment = async ({ amount }) => {
    let razorpayScript = await RazorpayScriptLoad();
    if (!razorpayScript) {
      Toast(
        false,
        "",
        "Razorpay SDK failed to load. Please check your connection.",
      );
      setStatus("failed");
      return;
    }
    setStatus("loading");

    try {
      const options = {
        key: "rzp_test_MuW12ePvQ8Q5BH",
        amount: amount * 100,
        currency: "INR",
        // order_id: "order_SaBNnAsJyeYIHu",paru
        order_id: "order_SbNL1HJjfW4qY2",

        // ✅ SUCCESS
        handler: async function (response) {
          setStatus("verifying");
          console.log("response on success handler", response);

          if (false) {
            setStatus("success");
          } else {
            localStorage.setItem("paymentStatus", "pending");
            setStatus("pending");
            Toast(false, "", "Payment is pending.");
          }
        },

        // ❌ CANCEL
        modal: {
          ondismiss: function (err) {
            console.error("Payment cancelled:", err);
            setStatus("cancelled");
          },
        },
      };

      if (!window.Razorpay) {
        Toast(
          false,
          "",
          "Razorpay SDK failed to load. Please check your connection.",
        );
        setStatus("failed");

        return;
      }
      const rzp = new window.Razorpay(options);
      rzp.open();

      // ❌ FAILURE
      rzp.on("payment.failed", function (err) {
        console.error("Payment failed:", err);
        setStatus("failed");
      });
    } catch (err) {
      console.error("An error occurred:", err);
      setStatus("failed");
    }
  };

  return {
    status,
    setStatus,
    handlePayment,
  };
};

export default useRazorpayPayment;
